import React, { useState, useEffect } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { WorkflowStepper } from "./WorkflowStepper";
import WorkflowStep7Chart from "./WorkflowStep7Chart";
import { WorkflowService } from "../service";
import { WorkflowStep7List } from "./WorkflowStep7List";
import { useTranslation } from "react-i18next";
import { WorkflowStep7ApexChart } from "./WorkflowStep7ApexChart";
import Chart from "react-apexcharts";
import { ErrorToast } from "../../../shared/toasters/toasters";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";

interface IInnerStatsInterface {
  done: number;
  total: number;
  percent: number;
}

interface IStatsInterface {
  baseData: IInnerStatsInterface;
  attributes: IInnerStatsInterface;
  copyWriting: IInnerStatsInterface;
  translation: IInnerStatsInterface;
  translatorsData: any[];
  copywritersData: any[];
}
const WorkflowStep7 = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState<IStatsInterface>();
  const [statsChart, setStatsChart] = useState<any>();
  const workflowData = useSelector((state: IAllStates) => state.workflow);
  const { id } = useParams();
  useEffect(() => {
    WorkflowService.getWorkflowCharts(+id!).then((res) => {
      setStats(res);
    });
  }, []);
  useEffect(() => {
    WorkflowService.getWorkflowGeneralStatistics(Number(id))
      .then((response) => {
        setStatsChart(response);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <Card>
      <Helmet>
        <title>
          {workflowData?.name ?? "-"} {t("workflow.OVERVIEW")}
        </title>
      </Helmet>
      <Card.Body>
        <WorkflowStepper id={id} step={"OVERVIEW"} />
        <div className="row mb-5">
          <WorkflowStep7Chart
            name={t("workflow.BASE_DATA")}
            iconClass={"ri-vip-crown-fill display-6 text-muted"}
            total={stats?.baseData.total}
            done={stats?.baseData.done}
          />
          <WorkflowStep7Chart
            name={t("workflow.ATTRIBUTES")}
            iconClass={"ri-vip-crown-fill display-6 text-muted"}
            total={stats?.attributes.total}
            done={stats?.attributes.done}
          />
          <WorkflowStep7Chart
            name={t("workflow.COPY_WRITING")}
            iconClass={"ri-vip-crown-fill display-6 text-muted"}
            total={stats?.copyWriting.total}
            done={stats?.copyWriting.done}
          />
          <WorkflowStep7Chart
            name={t("workflow.TRANSLATION")}
            iconClass={"ri-vip-crown-fill display-6 text-muted"}
            total={stats?.translation.total}
            done={stats?.translation.done}
          />
        </div>
        <WorkflowStep7List stats={stats} />
        <WorkflowStep7ApexChart statsChart={statsChart} />
      </Card.Body>
    </Card>
  );
};

export default WorkflowStep7;
